import React, { CSSProperties } from 'react';
import classNames from "classnames";
import { getItemSize, getPositionCss, normalizeAndPad } from "@/pages/datalab/components/GridBox/untils";
import './index.scss';
import {GridBoxComponent, GridBoxProps, GridBoxType} from "@/pages/datalab/components/GridBox/types";


const GridBoxItem = (props: any) => {
  const {
    ellipsis=true, // 超出单元格是否显示省略号, 默认显示
    row,
    col,
    className,
    type,
    ...rest
  } = props;
  
  // 单元格的位置, 兼容跨列
  
  const style: CSSProperties = {
    
    // gridColumnEnd: span 2, 跨2列
    
  };
  // 单元格跨列相关设置, 可以设置起始位置和终止位置, 也可以设置跨几列
  if (col) {
    style.gridColumn = getPositionCss(col);
  }
  // 单元格跨行相关设置, 可以设置起始位置和终止位置, 也可以设置跨几行
  if (row) {
    style.gridRow = getPositionCss(row);
  }
  
  
  return (<div
    {...rest}
    style={style}
    className={classNames( 'dbl-grid-box-cell', {'dbl-grid-box-cell-ellipsis': ellipsis, 'dbl-grid-box-cell-label': type === 'label'}, className)}
  >{props.children}</div>);
};


const GridBox: GridBoxComponent = (props: GridBoxProps) => {
  const {
    className,
    style,
    // ellipsis=true, // 超出单元格是否显示省略号, 默认显示
    gap, // 行和列之间的间距
    rowSizes,
    columnSizes,
    grid,
    type,
    ...restProps
  } = props;
  
  const allStyle: CSSProperties = {
    ...style,
    display: "grid",
    gap
  };
  // rowSizes 可以是 以数字为key的Object, 也可以是数组
  allStyle.gridTemplateRows = getItemSize(normalizeAndPad(rowSizes, grid.row, 'minmax(0, 1fr)'));
  allStyle.gridTemplateColumns = getItemSize(normalizeAndPad(columnSizes, grid.column, 'minmax(0, 1fr)'));
  
  return (
    <div
      {...restProps}
      style={allStyle}
      className={classNames('dbl-grid-box', {'dbl-grid-box-form': type === GridBoxType.Form}, className)}
    >
      {props.children}
    </div>
  );
};

GridBox.Item = GridBoxItem;

export default GridBox;